import script from "./AdminFormElementEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminFormElementEmail.vue?vue&type=script&setup=true&lang=js"

import "./AdminFormElementEmail.vue?vue&type=style&index=0&id=52294115&lang=scss"

const __exports__ = script;

export default __exports__